export default "__VITE_ASSET__DbeRXnwx__"